import { Link } from "react-router-dom";
import { Button } from "@/components/uiDir/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";
import { Share2, TrendingUp, Settings } from "lucide-react";

export const QuickActionsCard = () => {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <Link to="/dashboard/share">
          <Button variant="ghost" className="w-full justify-start" size="sm">
            <Share2 className="h-4 w-4 mr-3" />
            Share Portfolio
          </Button>
        </Link>
        <Link to="/dashboard/analytics">
          <Button variant="ghost" className="w-full justify-start" size="sm">
            <TrendingUp className="h-4 w-4 mr-3" />
            View Analytics
          </Button>
        </Link>
        <Link to="/dashboard/settings">
          <Button variant="ghost" className="w-full justify-start" size="sm">
            <Settings className="h-4 w-4 mr-3" />
            Edit Profile
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};